import Vue from 'vue'
import Router from 'vue-router'

// 首页
import PageHome from '@/views/home'

// 最新活动
import PageEvents from '@/views/event'
import PageEventDetail from '@/views/event-detail'
import PageEventSign from '@/views/event-sign'

// 申请加入
import PageJoin from '@/views/join'
// 申请表单
import PageApplyForm from '@/views/apply-form'

// 学员详情页
import PageDetail from '@/views/member-detail/Detail'

// 账户相关
import PageDashbord from '@/views/account'
import MyInfo from '@/views/account/my-info'
import MyGroup from '@/views/account/my-group'
import MyActivity from '@/views/account/my-activity'

// 公告
import PageNotice from '@/views/notice'
import PageNoticeDetail from '@/views/notice/notice-detail'

// 学员&全球分会
import PageWeMembers from '@/views/wemembers'
import PageWeBranches from '@/views/webranches'

// 培训体系
import PageTrainingChart from '@/views/trainingchart'
import PageTrainingTeachers from '@/views/trainingteachers'

// 关于TGO 鲲鹏会
import PageAboutPrivacy from '@/views/aboutprivacy'
import PageAboutUse from '@/views/aboutuse'
import PageAboutFAQ from '@/views/aboutFAQ'
import PageAboutFinance from '@/views/aboutfinance'
import PageAboutGlobal from '@/views/aboutglobal'

// 大鹏学社
// const PageClub = (resolve) => require(['@/views/club'], resolve)

// 404
import PageNotFound from '@/views/404'

import utils from '@/util'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      component: PageHome,
      meta: { title: '首页', headerStyle: { theme: 'opacity', position: 'absolute', sticky: { isSwitchTheme: true } } }
    },
    {
      path: '/together',
      redirect: '/',
      meta: { title: 'TGO' }
    },
    {
      path: '/home',
      redirect: '/',
      meta: { title: 'TGO', headerStyle: { theme: 'black' } }
    },
    {
      path: '/member',
      redirect: '/',
      meta: { title: 'TGO' }
    },
    {
      path: '/we/members',
      name: 'wemembers',
      component: PageWeMembers,
      meta: { title: '全球学员名单', auth: true, vip: true, isShowHeader: !utils.isInWXMiniProgram(), isShowFooter: !utils.isInWXMiniProgram() }
    },
    {
      path: '/we/branches',
      name: 'webranches',
      component: PageWeBranches,
      meta: { title: '董事会成员', headerStyle: { mobile: { position: 'absolute', sticky: false } } }
    },
    {
      path: '/event',
      name: 'events',
      component: PageEvents,
      meta: { title: '学员活动', headerStyle: { sticky: false } }
    },
    {
      path: '/event/sign',
      name: 'eventsign',
      component: PageEventSign,
      meta: { title: '活动签到', isShowHeader: false, isShowFooter: false }
    },
    {
      path: '/event/:id',
      name: 'eventdetail',
      component: PageEventDetail,
      meta: { title: '活动详情' }
    },
    {
      path: '/training/chart',
      name: 'trainingchart',
      component: PageTrainingChart,
      meta: { title: '培训章程' }
    },
    {
      path: '/training/teachers',
      name: 'trainingteachers',
      component: PageTrainingTeachers,
      meta: { title: '培训师' }
    },
    {
      path: '/join',
      name: 'join',
      component: PageJoin,
      meta: { title: '申请加入', headerStyle: { theme: 'opacity', position: 'absolute', sticky: false } }
    },
    {
      path: '/member/detail/:id',
      name: 'member',
      component: PageDetail,
      meta: { title: '学员信息' }
    },
    {
      path: '/apply',
      name: 'apply',
      component: PageApplyForm,
      meta: { title: '入会申请表单', hideGeoBanner: true, headerStyle: { theme: 'opacity', position: 'absolute', sticky: { isSwitchTheme: true } } }
    },
    {
      path: '/notice',
      name: 'notice',
      component: PageNotice,
      props: true,
      meta: { title: '公告新闻' }
    },
    {
      path: '/notice/detail/:id',
      name: 'noticeDetail',
      component: PageNoticeDetail,
      props: true,
      meta: { title: '公告详情' }
    },
    {
      path: '/about/privacy',
      name: 'aboutprivacy',
      component: PageAboutPrivacy,
      meta: { title: '隐私条款' }
    },
    {
      path: '/about/use',
      name: 'aboutuse',
      component: PageAboutUse,
      meta: { title: '使用条款' }
    },
    {
      path: '/about/FAQ',
      name: 'aboutFAQ',
      component: PageAboutFAQ,
      meta: { title: '常见问题', headerStyle: { mobile: { position: 'absolute', sticky: false } } }
    },
    {
      path: '/about/finance',
      name: 'aboutFinance',
      component: PageAboutFinance,
      meta: { title: 'TGO', headerStyle: { mobile: { position: 'absolute', sticky: false } } }
    },
    {
      path: '/about/global',
      name: 'aboutGlobal',
      component: PageAboutGlobal,
      meta: { title: 'TGO', headerStyle: { mobile: { position: 'absolute', sticky: false } } }
    },
    {
      path: '/dashbord',
      name: 'dashbord',
      component: PageDashbord,
      children: [
        {
          path: 'info',
          component: MyInfo,
          name: 'dashbord/info',
          meta: {
            auth: true,
            title: '个人中心',
            headerStyle: { sticky: false }
          }
        },
        {
          path: 'group',
          component: MyGroup,
          name: 'dashbord/group',
          meta: {
            auth: true,
            title: '我的小组',
            headerStyle: { sticky: false }
          }
        },
        {
          path: 'activity',
          component: MyActivity,
          name: 'dashbord/activity',
          meta: {
            auth: true,
            title: '我的活动',
            headerStyle: { sticky: false }
          }
        }
      ],
      meta: { title: '学员中心' }
    },
    // {
    //   path: '/dapeng',
    //   name: 'club',
    //   component: PageClub,
    //   meta: { title: '大鹏学社', isShowHeader: false, isShowFooter: false, headerStyle: { theme: 'opacity', position: 'absolute', sticky: { isSwitchTheme: true } } }
    // }

    {
      path: '/:pathMatch(.*)*',
      name: 'notFound',
      component: PageNotFound,
      meta: { title: '找不到相关内容' }
    }
  ]
})

// 谷歌统计
utils.GA('create', 'UA-103082599-8', 'auto')

// 在微信、钉钉环境下初始化接口
router.beforeEach((to, from, next) => {
  utils.initWxConfig().then(() => {
    next()
  }).catch(() => {
    next()
  })
})

router.afterEach((to, from) => {
  let { title } = to.meta

  if (title) {
    document.title = `${title} | TGO 鲲鹏会`
  }

  utils.GA('set', 'page', to.fullPath)
  utils.GA('send', 'pageview')

  utils.weixinshare()
})

export default router
